
import { defineComponent, PropType } from 'vue'
import { Block } from '@interfaces/BlockTypes'
import AppActions from '@constants/AppActions'
import { trackLinkedinAds } from '~/domain/helpers'
import CommonSalesDialog from '~/components/common/CommonSalesDialog.vue'

export default defineComponent({
  components: { CommonSalesDialog },
  props: {
    block: {
      type: Object as PropType<Block>,
      required: true,
    },
  },
  data() {
    return {
      googleCalendarLink: this.block.googleCalendarLink,
    }
  },
  methods: {
    async ctaButtonClicked() {
      if (this.block?.ctaButton?.enableTracking) {
        await this.$store.dispatch(AppActions.TRACK_SIGN_UP_EVENT, {
          context: this,
          location: this.block?.ctaButton?.trackingLocation,
          link: this.block?.ctaButton?.link || null,
        })
      }
    },
    salesButtonClicked() {
      trackLinkedinAds('book-demo')
      this.$store.dispatch(AppActions.TRACK_SEGMENT_EVENT, {
        context: this,
        params: {
          name: 'Demo - Request Demo',
          category: 'Goal completion',
          action: 'Request Demo',
          label: 'homepage_hero',
          misc: [{ type: 'location', value: 'homepage_hero_section' }],
        },
      })

      // @ts-ignore
      this.$refs.salesDialogRef?.talkToSalesClicked()
    },
  },
})
